module.exports = __webpack_public_path__ + "img/remoteDesk.eb58c8c2.png";